/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".red[_ngcontent-%COMP%] {\n  background-color: #e53935; }\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92YXIvamVua2luc19ob21lL3dvcmtzcGFjZS9CbHVlYmVlIEZyb250ZW5kL3NyYy9hcHAvcGFnZXMvdmVoaWNsZS1jYWxjdWxhdG9yL3ZlaGljbGUtY2FsY3VsYXRvci5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLHlCQUF5QixFQUFBIiwiZmlsZSI6InNyYy9hcHAvcGFnZXMvdmVoaWNsZS1jYWxjdWxhdG9yL3ZlaGljbGUtY2FsY3VsYXRvci5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5yZWQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZTUzOTM1O1xufVxuIl19 */"];
export { styles as styles };
